import React from 'react'
import { Box, Grid, Typography, Card, } from '@mui/material'
import TitleBar from 'components/TitleBar'
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";





const colorPalette = ["#3B00ED", "#9C27B0", "#D81B60", "#FF9800"];

const Incident = ({ data, months, grouped }) => {

    const monthOrder = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];



    const incidentMonthlyData = [
        { name: "Near Miss", value: data?.incident?.nearMiss || 0 },
        { name: "Incidents with no lost time", value: data?.incident?.incidentsWithNoLostTime || 0 },
        { name: "First Aid Case (FAC)", value: data?.incident?.firstAidCase || 0 },
        { name: "Medical Treatment Case (MTC)", value: data?.incident?.medicalTreatmentCase || 0 },
        { name: "Lost-Time incidents(LTI)", value: data?.incident?.lostTimeIncidents || 0 },
        { name: "Total No. of Fatality Case (FTC)", value: data?.incident?.totalNoOfFatalityCase || 0 },
        { name: "Fire theft or other property damage", value: data?.incident?.fireTheftIncidents || 0 }
    ]

    const total = incidentMonthlyData.reduce((sum, item) => sum + item.value, 0)

    const mainSeriesData = incidentMonthlyData.map((incident) => {

        return {
            name: incident.name,
            y: incident.value,
            drilldown: incident.name
        };

    });


    const drilldownSeries = incidentMonthlyData.map((incident) => {
        const monthlyData = grouped?.Incident?.[incident.name] || {};


        const sortedKeys = Object.keys(monthlyData).sort((a, b) => {
            const [monthA, yearA] = a.split(" ");
            const [monthB, yearB] = b.split(" ");

            if (yearA !== yearB) {
                return Number(yearA) - Number(yearB);
            }

            return monthOrder.indexOf(monthA) - monthOrder.indexOf(monthB);
        });


        return {
            name: incident.name,
            id: incident.name,
            data: sortedKeys.map((key) => {
                return [key, monthlyData[key] || 0];
            })
        };
    });

   


    const options = {

        chart: {
            type: 'column'
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ""
        },
        colors: ["#9C27B0"],
        accessibility: {
            announceNewData: {
                enabled: true
            }
        },
        xAxis: {
            type: 'category',
            
            labels: {
                style: {
                    color: "#6B7280",
                    textOutline: 'none',
                    fontSize: "12px",
                    fontWeight: 600,
                }
            }

        },
        yAxis: {
            title: {
                text: 'Total Value of Incidents',
                style: {
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#182A4E",
                    fontFamily: "Outfit, sans-serif",
                }
            }

        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            }
        },

        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
        },
        series: [
            {
                name: 'Incident',
                data: mainSeriesData
            }
        ],
        drilldown: {
            activeAxisLabelStyle: {
                color: "#6B7280",
                textDecoration: "none",
                fontWeight: 600,
            },
            activeDataLabelStyle: {
                color: "#6B7280",
                textDecoration: "none",
                fontWeight: 600,
            },
            breadcrumbs: {
                position: {
                    align: 'right'
                }
            },
            series: drilldownSeries
        },
        credits: {
            enabled: false
        }
    };

    return (
        <Card sx={{
            background: "#fff",
            borderRadius: 1,
            padding: 0,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
            border: "1px solid #E4E4E4",
            height: "100%"
        }}>
            <Grid size={12}>
                <TitleBar title={"Incident"} description={""} />
            </Grid>

            {total === 0 ? (
                <Typography
                    sx={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#9CA3AF",
                        fontSize: "14px",
                        fontWeight: 500
                    }}
                >
                    No Data Available
                </Typography>
            ) : (
                <HighchartsReact highcharts={Highcharts} options={options} />
            )}

        </Card>
    )
}

export default Incident
